import React, { useRef, useEffect } from "react";
import styles from "./LanguageSwitch.module.css";
import { useLanguage } from "../../context/LanguageContext/LanguageContext";
import plFlag from "../../assets/icons/pl_flag.svg";
import ukFlag from "../../assets/icons/uk_flag.svg";

const languages = [
  { code: "pl", name: "Polski", flag: plFlag },
  { code: "en", name: "English", flag: ukFlag },
];

interface LanguageSwitchProps {
  responsive?: boolean;
}

const LanguageSwitch: React.FC<LanguageSwitchProps> = ({ responsive }) => {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = React.useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLanguageChange = (langCode: string) => {
    setLanguage(langCode);
    setIsOpen(false);
  };

  const selectedLanguage = languages.find((lang) => lang.code === language);

  return (
    <div className={`${styles.languageSwitch} ${responsive ? styles.responsive : styles.nonResponsive}`} ref={menuRef}>
      <button
        className={styles.trigger}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Language menu"
        aria-expanded={isOpen}
      >
        <img src={selectedLanguage?.flag} alt={selectedLanguage?.name} className={styles.flag} />
      </button>
      {isOpen && (
        <div className={styles.menu}>
          {languages.map((lang) => (
            <button
              key={lang.code}
              className={`${styles.option} ${language === lang.code ? styles.active : ""}`}
              onClick={() => handleLanguageChange(lang.code)}
            >
              <img src={lang.flag} alt={lang.name} className={styles.flag} />
              <span className={styles.langName}>{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitch;
